/*<-----imports--------->*/
import React, { Component } from "react";
import { SearchBox } from "./company-search-box/company-search-box.component";
import { CardList } from "./company-card-list/company-card-list.component";
import Heading from "../general/heading/heading.component";
import Header from "../general/Headers/Header";
import "./companies.css";
import Footer from "../general/Footer/Footer";
import { Grid } from "@mui/material";
/*<-----imports--------->*/

class Companies extends Component {
  constructor() {
    super();

    this.state = {
      companies: [],
      searchField: "",
    };
  }

  /* arrow function to handle state */
  handleChange = (e) => {
    this.setState({ searchField: e.target.value });
  };

  /* accessing external json link = https://api.jsonbin.io/b/61f3da261960493ad183ecd6 */
  componentDidMount() {
    fetch("https://api.jsonbin.io/b/62224ab4a703bb6749223d03")
      .then((response) => response.json())
      .then((element) => this.setState({ companies: element }));
  }

  render() {
    /* destructuring */
    const { companies, searchField } = this.state;

    /* filter through user input for name */
    const filteredCompany = companies.filter((company) =>
      company.name.toLowerCase().includes(searchField.toLowerCase())
    );

    return (
      <div className="Companies">
        <Header />
        <br /> <br /> <br /> <br />
        <Heading text="Companies" />
        <SearchBox handleChange={this.handleChange} />
        <CardList companies={filteredCompany}></CardList>
        <br /> <br /> <br /> <br />
        <Grid item lg={12}>
          <Footer />
        </Grid>
      </div>
    );
  }
}

export default Companies;
